module.exports = {
	"ha": "nha",
	"id": 5.3,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Northern Health by Age Category, Year Ending 2022 Q4 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -195,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "55%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "55%",
				"height": "45%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -80,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 68.42105263157895,
						"dataLabels": {
							"enabled": true,
							"format": "13",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 57.89473684210527,
						"dataLabels": {
							"enabled": true,
							"format": "11",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 52.63157894736842,
						"dataLabels": {
							"enabled": true,
							"format": "10",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 47.368421052631575,
						"dataLabels": {
							"enabled": true,
							"format": "9",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 36.84210526315789,
						"dataLabels": {
							"enabled": true,
							"format": "7",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": true,
							"format": "34",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 94.11764705882352,
						"dataLabels": {
							"enabled": true,
							"format": "32",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 88.23529411764706,
						"dataLabels": {
							"enabled": true,
							"format": "30",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 67.64705882352942,
						"dataLabels": {
							"enabled": true,
							"format": "23",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 29.411764705882355,
						"dataLabels": {
							"enabled": true,
							"format": "10",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.33333333333333,
						"dataLabels": {
							"enabled": true,
							"format": "59",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 96.66666666666667,
						"dataLabels": {
							"enabled": true,
							"format": "58",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 90,
						"dataLabels": {
							"enabled": true,
							"format": "54",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 71.66666666666667,
						"dataLabels": {
							"enabled": true,
							"format": "43",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 28.333333333333332,
						"dataLabels": {
							"enabled": true,
							"format": "17",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96.93251533742331,
						"dataLabels": {
							"enabled": true,
							"format": "158",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 90.79754601226993,
						"dataLabels": {
							"enabled": true,
							"format": "148",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 88.34355828220859,
						"dataLabels": {
							"enabled": true,
							"format": "144",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.75460122699386,
						"dataLabels": {
							"enabled": true,
							"format": "130",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 48.466257668711656,
						"dataLabels": {
							"enabled": true,
							"format": "79",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -31.57894736842105,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -15.384615384615385,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -22.22222222222222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.882352941176472,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -23.33333333333333,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -56.52173913043479,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.6666666666666718,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -1.6949152542372836,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.896551724137934,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -20.370370370370374,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -60.46511627906976,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -3.0674846625766916,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.329113924050633,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -2.7027027027026973,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.722222222222221,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -39.23076923076923,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=19"
			},
			{
				"x": 9,
				"text": "30–39<br>n=34"
			},
			{
				"x": 15,
				"text": "40–49<br>n=60"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=163"
			}
		],
		"dataTable": {
			"< 30": [
				19,
				13,
				11,
				10,
				9,
				7
			],
			"30–39": [
				34,
				34,
				32,
				30,
				23,
				10
			],
			"40–49": [
				60,
				59,
				58,
				54,
				43,
				17
			],
			"≥ 50": [
				163,
				158,
				148,
				144,
				130,
				79
			]
		}
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_nha_5_3.json
// module id = 270
// module chunks = 0